"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIdsForAction = getIdsForAction;
const mapEntityListRequest_1 = require("./mapEntityListRequest");
async function getIdsForAction(props, storage, selectedRowIds, filterData, sortColumnKey, sortColumnDesc, all) {
    if (all) {
        const result = await storage.list((0, mapEntityListRequest_1.mapEntityListRequest)(props, { sortColumnKey, sortColumnDesc }));
        return result.rows.map((row) => row.id);
    }
    else {
        if (selectedRowIds && selectedRowIds.length > 0) {
            return selectedRowIds;
        }
        else {
            const result = await storage.list((0, mapEntityListRequest_1.mapEntityListRequest)(props, { filterData, sortColumnKey, sortColumnDesc }));
            return result.rows.map((row) => row.id);
        }
    }
}
